import { BOOKING_DETAIL_ROUTE, BOOKING_OVERVIEW_ROUTE } from '../general/router/constants';
import { allPermissions } from '../general/utils/authHelper';
import CommonFilterType from '../shared/constants/CommonFilterType';
import Permission from '../shared/constants/Permission';
import { bookingDetailLoader, bookingOverviewLoader, chatLoader } from './loaders';

const BookingDetailPage = () => import('./views/BookingDetailPage.vue');
const BookingsOverviewPage = () => import('./views/BookingsOverviewPage.vue');

const BOOKING_OVERVIEW_FILTERS = [CommonFilterType.OUTLET_OPTIONAL, CommonFilterType.DOSSIER_TAG];

export default [
  {
    path: '/bookings',
    name: BOOKING_OVERVIEW_ROUTE,
    component: BookingsOverviewPage,
    meta: {
      hasAccess: allPermissions(Permission.ACCESS_TO_BOOKINGS),
      title: 'bookingList.title',
      commonFilters: BOOKING_OVERVIEW_FILTERS,
    },
    props: {
      context: bookingOverviewLoader,
    },
  },
  {
    path: '/booking/:bookingId',
    name: BOOKING_DETAIL_ROUTE,
    component: BookingDetailPage,
    meta: {
      hasAccess: allPermissions(Permission.ACCESS_TO_BOOKINGS),
    },
    props: {
      context: bookingDetailLoader,
      chatContext: chatLoader,
    },
  },
];
